export default {
  common: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    view: 'Bekijken',
    back: 'Terug',
    close: 'Sluiten',
    add: 'Toevoegen',
    send: 'Verzenden',
    sending: 'Verzenden...',
    saving: 'Opslaan...',
    loading: 'Laden...',
    search: 'Zoeken',
    update: 'Bijwerken',
    create: 'Aanmaken',
    creating: 'Aanmaken...',
    transfer: 'Overdragen',
    approve: 'Goedkeuren',
    reject: 'Afwijzen',
    ok: 'Begrepen',
    name: 'Naam',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    email: 'E-mail',
    date: 'Datum',
    status: 'Status',
    type: 'Type',
    quantity: 'Hoeveelheid',
    description: 'Beschrijving',
    project: 'Project',
    task: 'Taak',
    logout: 'Uitloggen',
    notifications: 'Meldingen',
    settings: 'Instellingen',
    draft: 'Concept',
    sent: 'Verzonden',
    active: 'Actief',
    inactive: 'Inactief',
    priority: 'Prioriteit',
    language: 'Taal',
    yes: 'Ja',
    no: 'Nee',
    error: 'Fout',
    success: 'Geslaagd',
    warning: 'Waarschuwing',
    required: 'Verplicht',
    optional: 'Optioneel',
    all: 'Alle',
    none: 'Geen',
    upload: 'Bestand uploaden',
    download: 'Downloaden',
    print: 'Afdrukken',
    actions: 'Acties',
    details: 'Details',
    filters: 'Filters',
    results: 'Resultaten',
    noResults: 'Geen resultaten gevonden',
    total: 'Totaal',
    of: 'van',
    verified: 'geverifieerd',
    pending: 'In behandeling',
    completed: 'Voltooid',
    cancelled: 'Geannuleerd',
  },

  auth: {
    login: 'Inloggen',
    loginTitle: 'Inloggen bij uw account',
    logout: 'Uitloggen',
    register: 'Registreren',
    forgotPassword: 'Wachtwoord vergeten?',
    resetPassword: 'Wachtwoord opnieuw instellen',
    usernameOrEmail: 'Gebruikersnaam of e-mail',
    enterPassword: 'Voer uw wachtwoord in',
    enterUsername: 'Voer uw gebruikersnaam in',
    loginError: 'Onjuiste gebruikersnaam of wachtwoord.',
    sessionExpired: 'Sessie verlopen. Meld u opnieuw aan.',
  },

  nav: {
    dashboard: 'Dashboard',
    overview: 'Overzicht',
    documents: 'Documenten',
    viewDocuments: 'Documenten bekijken',
    manageProjects: 'Projecten beheren',
    viewProjects: 'Projecten bekijken',
    manageUsers: 'Gebruikers beheren',
    viewUsers: 'Gebruikers bekijken',
    manageWarehouse: 'Magazijn beheren',
    viewWarehouse: 'Magazijn bekijken',
    manageMachinery: 'Machines beheren',
    viewMachinery: 'Machines bekijken',
    manageSystem: 'Systeem beheren',
    projects: 'Projecten',
    myProjects: 'Mijn projecten',
    myTasks: 'Mijn taken',
    reports: 'Rapporten',
    drawings: 'Tekeningen',
    warehouse: 'Magazijn',
    checkStock: 'Voorraad controleren',
    requests: 'Verzoeken',
    requestItem: 'Item aanvragen',
    tickets: 'Tickets',
    messages: 'Berichten',
    adminMode: 'Beheerdersmodus',
    standardMode: 'Standaardmodus',
    analystMode: 'Analystmodus',
    createReport: 'Rapport aanmaken',
    createReports: 'Bouwrapporten',
    dailyReport: 'Dagelijks bouwrapport',
    incidentReport: 'Incidentrapport',
    safetySection: 'Arbeidsveiligheid',
    safetyDialog: 'Veiligheidsdialogen',
    workPermit: 'Kritische werkvergunning',
    occurrenceReport: 'Voorvalrapport',
    settingsMenu: 'Instellingen',
  },

  profile: {
    editProfile: 'Profiel bewerken',
    displayName: 'Naam',
    usernameLabel: 'Gebruikersnaam',
    passwordLabel: 'Wachtwoord',
    changePassword: 'Wachtwoord wijzigen',
    appearance: 'Uiterlijk',
    lightMode: 'Lichte modus',
    darkMode: 'Donkere modus',
    languageLabel: 'Taal',
    cropTitle: 'Profielfoto bijsnijden',
    cropUse: 'Dit gebied gebruiken',
    zoom: 'Zoom',
    currentPassword: 'Huidig wachtwoord bevestigen',
    newPassword: 'Nieuw wachtwoord',
    confirmNewPassword: 'Nieuw wachtwoord bevestigen',
    emailVerified: 'geverifieerd',
    emailChange: 'Wijzigen',
    emailSendCode: 'Code verzenden',
    emailConfirm: 'Bevestigen',
    emailResend: '← Code opnieuw verzenden',
    emailCancelChange: 'Annuleren',
    emailSending: 'Verzenden...',
    emailVerifying: 'Verifiëren...',
    emailHint: 'Code verzonden naar {email}. Controleer uw inbox en spam.',
    emailSuccess: 'E-mail {email} succesvol geverifieerd.',
    emailInvalidError: 'Voer een geldig e-mailadres in.',
    emailGenericError: 'Fout bij verzenden van code.',
    emailInvalidCode: 'Ongeldige code.',
    passwordFillAll: 'Vul alle wachtwoordvelden in.',
    passwordWrong: 'Het huidige wachtwoord is onjuist.',
    passwordMismatch: 'De bevestiging van het nieuwe wachtwoord komt niet overeen.',
    saveFillAll: 'Vul naam en gebruikersnaam in.',
    saveFinishPassword: 'Voltooi of annuleer de wachtwoordwijziging voor het opslaan.',
    avatarAlt: 'profiel',
  },

  dashboard: {
    overview: 'Overzicht',
    myProjects: 'Mijn projecten',
    myTasks: 'Mijn taken',
    activeProjects: 'Actieve projecten',
    completedTasks: 'Voltooide taken',
    pendingTasks: 'Openstaande taken',
    recentActivity: 'Recente activiteit',
    noProjects: 'Geen projecten gevonden.',
    noTasks: 'Geen taken gevonden.',
    createProject: 'Project aanmaken',
    projectName: 'Projectnaam',
    startDate: 'Startdatum',
    endDate: 'Einddatum',
  },

  projects: {
    title: 'Projecten',
    newProject: 'Nieuw project',
    projectName: 'Projectnaam',
    startDate: 'Start',
    endDate: 'Einde',
    progress: 'Voortgang',
    team: 'Team',
    gantt: 'Planning',
    files: 'Bestanden',
    tickets: 'Tickets',
    warehouse: 'Magazijn',
    dds: 'Veiligheidsgesprek',
    reports: 'Rapporten',
    noProjects: 'Geen projecten.',
    deleteConfirm: 'Weet u zeker dat u dit project wilt verwijderen?',
  },

  tasks: {
    title: 'Taken',
    newTask: 'Nieuwe taak',
    taskName: 'Taaknaam',
    assignee: 'Verantwoordelijke',
    dependencies: 'Afhankelijkheden',
    duration: 'Duur (dagen)',
    startDate: 'Start',
    endDate: 'Einde',
    progress: 'Voortgang',
    addProgress: 'Voortgang registreren',
    noTasks: 'Geen taken.',
    blocked: 'Geblokkeerd',
    inProgress: 'In uitvoering',
    done: 'Voltooid',
    deleteConfirm: 'Deze taak verwijderen?',
  },

  warehouse: {
    title: 'Magazijn',
    stock: 'Voorraad',
    requestItem: 'Item aanvragen',
    requests: 'Verzoeken',
    addItem: 'Item toevoegen',
    itemName: 'Itemnaam',
    category: 'Categorie',
    unit: 'Eenheid',
    available: 'Beschikbaar',
    reserved: 'Gereserveerd',
    transferItem: 'Item overdragen',
    reportDamage: 'Schade melden',
    provideEquipment: 'Uitrusting verstrekken',
    noItems: 'Geen items op voorraad.',
    noRequests: 'Geen verzoeken.',
    approveRequest: 'Verzoek goedkeuren',
    rejectRequest: 'Verzoek afwijzen',
    requestStatus: {
      pending: 'In behandeling',
      approved: 'Goedgekeurd',
      rejected: 'Afgewezen',
      delivered: 'Geleverd',
    },
  },

  safety: {
    title: 'Veiligheid',
    dds: 'Veiligheidsgesprek',
    ddsTitle: 'Dagelijks veiligheidsdialoog',
    newDds: 'Nieuw veiligheidsgesprek',
    occurrences: 'Voorvallen',
    permits: 'Vergunningen',
    createDialog: 'Dialoog aanmaken',
    createOccurrence: 'Voorval registreren',
    createPermit: 'Vergunning aanmaken',
    topic: 'Onderwerp',
    presenter: 'Presentator',
    attendees: 'Deelnemers',
    date: 'Datum',
    noSafety: 'Geen veiligheidsregistraties.',
  },

  tickets: {
    title: 'Tickets',
    newTicket: 'Nieuw ticket',
    subject: 'Onderwerp',
    category: 'Categorie',
    openedBy: 'Geopend door',
    assignedTo: 'Toegewezen aan',
    openTickets: 'Open tickets',
    closedTickets: 'Gesloten tickets',
    noTickets: 'Geen tickets.',
    status: {
      open: 'Open',
      inProgress: 'In uitvoering',
      closed: 'Gesloten',
    },
  },

  users: {
    title: 'Gebruikers',
    newUser: 'Nieuwe gebruiker',
    role: 'Functie',
    roles: {
      adminMaster: 'Hoofdbeheerder',
      adminObra: 'Bouwbeheerder',
      user: 'Gebruiker',
    },
    noUsers: 'Geen gebruikers.',
    deleteConfirm: 'Deze gebruiker verwijderen?',
    manageRoles: 'Functies beheren',
    manageUsers: 'Gebruikersbeheer',
    userList: 'Gebruikerslijst',
  },

  system: {
    title: 'Systeeminstellingen',
    siteName: 'Systeemnaam',
    logo: 'Logo',
    loginBackground: 'Inlogachtergrond',
    primaryColor: 'Primaire kleur',
    save: 'Instellingen opslaan',
    saved: 'Instellingen opgeslagen.',
  },

  reports: {
    title: 'Rapporten',
    daily: 'Dagelijks rapport',
    incident: 'Incidentrapport',
    noReports: 'Geen rapporten.',
    createReport: 'Rapport aanmaken',
    date: 'Datum',
    author: 'Auteur',
    content: 'Inhoud',
  },

  machinery: {
    title: 'Zwaar materieel',
    newMachine: 'Nieuw materieel',
    machineName: 'Naam',
    model: 'Model',
    plate: 'Kenteken',
    status: 'Status',
    noMachinery: 'Geen materieel.',
  },

  messenger: {
    title: 'Berichten',
    newMessage: 'Nieuw bericht',
    noMessages: 'Geen berichten.',
    typeMessage: 'Typ een bericht...',
    send: 'Verzenden',
  },
}
